// extracted by mini-css-extract-plugin
export default {"content":"_1nSOC___Layout-module__content","mobileFullWidth":"CmFYY___Layout-module__mobileFullWidth"};